// Roles.js

export const RolesHomeCare = [
    {
        key: "ADMIN-HC",
        text: "ADMIN-HC",
        value: "ADMIN-HC",
        dominio: "HC",
    },
    {
        key: "SUPERVISOR-HC",
        text: "SUPERVISOR-HC",
        value: "SUPERVISOR-HC",
        dominio: "HC",
    },
    {
        key: "TRANSPORTE-HC",
        text: "TRANSPORTE-HC",
        value: "TRANSPORTE-HC",
        dominio: "HC",
    },
];

export const RolesST = [
    {
        key: "ADMIN-LMST",
        text: "ADMIN-LMST",
        value: "ADMIN-LMST",
        dominio: "ST",
    },
    {
        key: "TECNICO-LMST",
        text: "TECNICO-LMST",
        value: "TECNICO-LMST",
        dominio: "ST",
    },
];

export const RolesTodos = [
    ...RolesHomeCare,
    ...RolesST,
];

// Compatibilidad con los componentes antiguos.
// Históricamente "Roles" correspondía al dominio HomeCare.
export const Roles = RolesHomeCare;